import { axiosInstance } from ".";

const getDailyReportsRequestsList = async (params) =>
  await axiosInstance.get("/working_logs", { params });

const exportExcelRequest = async (params) =>
  await axiosInstance.get("/working_logs/export_report", { params });

export { getDailyReportsRequestsList, exportExcelRequest };
